import { createContext } from 'react'

const TouchDeviceContext = createContext(true)

export default TouchDeviceContext
